import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService } from "../../services/index";
import { SalesInvoiceService } from "../../services/salesinvoice.service";
import { PartyService, SalesOrderService, PurchaseOrderService } from "../../services/index";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./categorymaster.html",
})
export class categorymaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
 
  execApi: boolean = true;
  show_det: boolean = true;

  invoicedata: any = {
   category: "",
   fs_rate: "",
   hs_rate:"",
   mrp:"",
   brand:"",
  };
  
 brandList = ["EXPOSE","ARAZA"];
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  seasonList: any;
  dataList = [];
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private partyService: PartyService
  ) {
    this.row = {
     category: "",
      fs_rate: "",
      hs_rate: "",
     mrp: "",
     brand:"",
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this. getMasterDetails();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
  }

  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }


  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    row['widthlist'] = this.data.invoiceList;
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD CATEGORY MASTER",
          title: "ADD CATEGORY MASTER",
          tabParent: "CATEGORY",
          mode: mode,
          data: row,
          name: "ADD CATEGORY MASTER",
          // upd_type: this.shade_upd,
        },
      };
    }
    this.tabUpdateEvent.emit(tabObj);
  }


  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  
  onbackdet(){
    this.show_det = true;
    console.log(this.data.invoiceList);
    this.getMasterDetails()
  }
  getMasterDetails() {

    let params = {
      
      category: this.invoicedata.category,
      fs_rate:this .invoicedata.fs_rate,
      hs_rate:this .invoicedata.hs_rate,
      mrp:this.invoicedata.mrp,
      brand:this.invoicedata.brand,

    };
    console.log(this.invoicedata);
    this.salesinvservice.getcategoryMasterDetails(params).then((res: any) => {
      this.dataList = res.data;
      this.data.invoiceList = res.data;
      console.log(this.data.invoiceList);
      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);

    });
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getEditMode(ind){
this.mode = 'Edit';
console.log(this.data.invoiceList);

  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  oncheckemptyrow(){
   
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data.invoiceList);
      let that = this;

      swal({
        title: "Are you sure to save this Changes?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .savecategoryMasterDetails(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                this. getMasterDetails();
              } else {
                this. getMasterDetails();
                // let tabObj = {
                //   action: "CloseTab",
                //   params: {},
                // };
                // that.tabUpdateEvent.emit(tabObj);
              }
            }
            else {
              swal("This Design" +" " + res.message);
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
   
  }
  
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/categorymaster.ts